import { parseISO, parse } from 'date-fns';
var ISO_DATE_REGEX = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)\+(\d{2}):(\d{2})$/;
// TODO: remove this function when php will send the date ISO format
export var parseDate = function (date) {
    if (ISO_DATE_REGEX.test(date)) {
        return parseISO(date);
    }
    return parse(date, 'HH:mm dd.MM.yyyy', new Date());
};
